import { render, staticRenderFns } from "./template001.vue?vue&type=template&id=4d7540e4&scoped=true"
import script from "./template001.vue?vue&type=script&lang=js"
export * from "./template001.vue?vue&type=script&lang=js"
import style0 from "./template001.vue?vue&type=style&index=0&id=4d7540e4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d7540e4",
  null
  
)

export default component.exports